import React from 'react';

/**
 * Text input / textarea with the Yapp focus ring (indigo glow). Set
 * `as="textarea"` for multi-line. Supports a leading icon and label.
 */
export function Input({
  as = 'input',
  label,
  icon = null,
  error = '',
  fullWidth = true,
  style = {},
  id,
  ...rest
}) {
  const [focus, setFocus] = React.useState(false);
  const reactId = React.useId();
  const inputId = id || reactId;
  const Tag = as;

  const field = (
    <div style={{ position: 'relative', display: 'flex', alignItems: 'center', width: fullWidth ? '100%' : 'auto' }}>
      {icon && (
        <span style={{
          position: 'absolute', left: '0.75rem', color: 'var(--text-muted)',
          fontSize: 'var(--text-sm)', pointerEvents: 'none', display: 'flex',
        }}>{icon}</span>
      )}
      <Tag
        id={inputId}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        style={{
          width: '100%',
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--text-base)',
          color: 'var(--text-strong)',
          background: 'var(--surface-card)',
          padding: as === 'textarea' ? '0.75rem 0.85rem' : '0.6rem 0.85rem',
          paddingLeft: icon ? '2.25rem' : undefined,
          minHeight: as === 'textarea' ? '110px' : undefined,
          resize: as === 'textarea' ? 'vertical' : undefined,
          border: `1.5px solid ${error ? 'var(--danger-500)' : (focus ? 'var(--brand-500)' : 'var(--border-strong)')}`,
          borderRadius: 'var(--radius-sm)',
          outline: 'none',
          boxShadow: focus && !error ? `0 0 0 3px var(--focus-ring)` : 'none',
          transition: 'border-color var(--duration-fast) var(--ease-standard), box-shadow var(--duration-fast) var(--ease-standard)',
          ...style,
        }}
        {...rest}
      />
    </div>
  );

  if (!label && !error) return field;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem', width: fullWidth ? '100%' : 'auto' }}>
      {label && (
        <label htmlFor={inputId} style={{
          fontSize: 'var(--text-sm)', fontWeight: 'var(--weight-medium)', color: 'var(--text-body)',
        }}>{label}</label>
      )}
      {field}
      {error && <span style={{ fontSize: 'var(--text-xs)', color: 'var(--danger-500)' }}>{error}</span>}
    </div>
  );
}
